<template>
  <div class="sys-menu-page main-layout">
    <el-card class="box-outter">
      <c-title slot="header" title="字典管理" :back="false"></c-title>
      <el-card class="box-table box-inner" shadow="never">
        <div slot="header" class="btn-group">
          <div class="btn-left">
            <div class="opt-btn" title="新增" @click="goto('')">
              <i class="iconfont icon-add"></i>
            </div>
          </div>
          <!-- 右侧操作按钮 -->
          <table-btns
            :tableColumns="tableColumns"
            @tableColumnsChange="tableColumnsChange"
            @refresh="getTableTree"
          ></table-btns>
        </div>
        <div style="height: 100%">
          <el-table
            height="calc(100% - 40px)"
            :data="tableData"
            style="width: 100%"
            row-key="id"
            border
            lazy
            v-loading="pageLoading"
            :tree-props="{
              children: 'childrenList',
              hasChildren: 'hasChildren',
            }"
          >
            <template v-for="item in tableColumns">
              <el-table-column
                v-if="item.show"
                :key="item.label"
                :label="item.label"
                :align="item.align || 'center'"
                header-align="center"
                :width="item.width"
                :prop="item.prop"
              >
              </el-table-column>
            </template>
            <el-table-column label="操作" header-align="center" width="180px">
              <template slot-scope="scope">
                <div class="contr-btn-group">
                  <div
                    v-if="scope.row.parentId == '#root'"
                    class="contr-btn"
                    title="添加下级"
                    @click="goto(scope.row, 'add')"
                  >
                    <i class="iconfont icon-xiaji"></i>
                  </div>
                  <div
                    class="contr-btn"
                    title="编辑"
                    @click="goto(scope.row, 'edit')"
                  >
                    <i class="iconfont icon-edit"></i>
                  </div>
                  <div
                    class="contr-btn"
                    title="删除"
                    @click="handleDeleteMenu(scope.row.id)"
                  >
                    <i class="iconfont icon-shanchu"></i>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="padding-top: 10px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageParams.currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageParams.total"
          >
          </el-pagination>
        </div>
      </el-card>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            :formRules="formRules"
            label-width="150px"
            ref="cForm"
            @submit="submit"
            @resetFields="resetFields"
          >
            <el-form-item label="上级字典名称">
              <el-select
                style="width: 100%"
                v-model="handleData.parent"
                placeholder="请选择"
                value-key="id"
                @change="parentChange"
                :disabled="parentDisabled"
                clearable
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.dictValue"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <c-form-item :formItems="formItems" />
          </c-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/dic";
import { mapState } from "vuex";
let mHandle = MHandle({
  handleGetPath: "",
  handleInsertPath: "/account/sys/dict/save",
  handleUpdatePath: "/account/sys/dict/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mHandle],
  data() {
    let { tableColumns, formItems, formRules, tree } = Configs(this);
    return {
      formItems,
      formRules,
      tableColumns,
      tree,
      dialogFormVisible: false,
      title: "",
      tableData: [],
      pageLoading: false,
      defaultProps: {
        children: "childrenList",
        label: "name",
      },
      defaultHandleData: {
        id: "",
        dictKey: "",
        dictValue: "",
        type: "",
        description: "",
        parentId: "",
        parent: {},
      },
      pageParams: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        currentPage: 1,
      },
      parentDisabled: false,
      options: [],
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
  },
  created() {},
  mounted() {
    // 获取表格数据
    this.getTableTree(true);
    this.getListAll();
  },
  methods: {
    // 查询全部 /sys/dict/listAll
    getListAll() {
      this.$http.get("/account/sys/dict/listAll").then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          this.options = res.data;
        }
      });
    },
    // 刷新表格
    refresh() {
      // this.pageParams = {};
      this.getTableTree();
    },
    // 表格展示列动态改变
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 打开新增或编辑弹框
    goto(data, type) {
      let id = data.id;
      this.handleData = Object.assign({}, this.defaultHandleData);
      this.dialogFormVisible = true;
      if (id) {
        this.parentDisabled = true;
        this.formItems[0].disabled = true;
        if (type == "add") {
          this.title = "新增字典";
          this.handleData.parent = { id: data.id };
          this.handleData.type = data.type;
        } else {
          this.title = "编辑字典";
          this.handleData = Object.assign({}, data);
          this.handleData.parent = { id: data.parentId };
        }
      } else {
        this.formItems[0].disabled = false;
        this.parentDisabled = false;
        this.title = "新增字典";
      }
    },
    // 获取树状结构表格数据
    getTableTree(flag) {
      if (flag) {
        this.pageParams.pageSize = 10;
        this.pageParams.pageNum = 1;
        this.pageParams.total = 0;
        this.pageParams.currentPage = 0;
      }
      this.pageLoading = true;
      let params = { ...this.pageParams };
      this.$http
        .get("/account/sys/dict/list", { params })
        .then((res) => {
          console.log(res);
          this.pageLoading = false;
          if (res.code == this.SUCCESS_CODE) {
            this.tableData = res.data.records;
            this.pageParams.total = res.data.total;
            this.pageParams.currentPage = res.data.current;
          } else {
            this.$message.error(`获取数据失败，${res.msg}`);
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          this.$message.error(`获取数据失败，${err}`);
        });
    },
    // 删除单项
    handleDeleteMenu(id) {
      let title = "此操作将永久删除该数据, 是否继续?";
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$http
            .get(`/account/sys/dict/` + id, {
              headers: {
                "X-HTTP-Method-Override": "DELETE",
              },
            })
            .then((res) => {
              console.log(res);
              if (res.code == this.SUCCESS_CODE) {
                this.$message({
                  message: "恭喜你，删除成功！",
                  type: "success",
                });
                // 删除成功后重新获取表格数据
                this.getTableTree();
              } else {
                this.$message.error(`删除数据失败，${res.msg}`);
              }
            })
            .catch((err) => {
              this.$message.error(`删除数据失败，${err}`);
            });
        })
        .catch((err) => (err) => console.warn(err));
    },
    handleDialogClose() {
      this.handleData = Object.assign({}, this.defaultHandleData);
    },
    resetFields() {
      this.dialogFormVisible = false;
      // this.resetHanleData();
    },
    submit() {
      // console.log(this.handleData)
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleAfterFn() {
      this.dialogFormVisible = false;
      this.getTableTree(true);
      this.getListAll();
    },
    // 树节点点击事件
    handleNodeClick(data) {
      console.log(data);
      this.parentName = data.name;
      this.parentId = data.id;
      this.isSelcetTree = false;
    },
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.getTableTree();
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.getTableTree();
    },
    parentChange(data) {
      console.log(data);
      if (data) {
        this.handleData.type = data.type;
        this.formItems[0].disabled = true;
      } else {
        this.formItems[0].disabled = false;
      }
    },
    handleBeforeFn(data) {
      let params = Object.assign({}, data);
      params.parentId = params.parent.id;
      delete params.parent;
      return params;
    },
  },
};
</script>

